"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _color = _interopRequireDefault(require("color"));

var _styling = require("../../../toolkit/styling");

var _providers = require("../../../toolkit/providers");

var _SideProgressItem = _interopRequireDefault(require("./SideProgressItem"));

//
//  SideProgressList.tsx
//  Project-Lego
//
//  Created by Jack Zhu on 4/15/2020
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//

/* External Libraries */

/* Lego Toolkit */

/* Relative Imports */
var demoRender = "\n<SideProgressList style={{paddingTop: \"20px\", paddingBottom: \"20px\"}}>\n  <SideProgressList.Item \n    hasCompleted={true}\n    selected={false}\n  >\n    private get Started\n  </SideProgressList.Item> \n  <SideProgressList.Item \n    hasCompleted={false}\n    selected={true}\n    >\n    <Markdown text={\"**Business Address**\"}/>\n  </SideProgressList.Item> \n  <SideProgressList.Item \n    hasCompleted={false}\n    selected={false}\n    >\n    Phone Number\n  </SideProgressList.Item>   \n</SideProgressList>\n  ";
var discussion = "Side Progress List Navigation";

var SideProgressList = function SideProgressList(props) {
  var className = props.className,
      style = props.style;
  var styles = useStylesheet();
  var passedInChildren = useChildren(props);
  var rootCSS = (0, _styling.css)(styles.root, style, className);

  if (passedInChildren.length === 0) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootCSS
  }, passedInChildren);
};

SideProgressList.Item = _SideProgressItem["default"];
SideProgressList.demoRender = demoRender;
SideProgressList.discussion = discussion;
var _default = SideProgressList;
exports["default"] = _default;

var useChildren = function useChildren(props) {
  var children = props.children;
  return (0, _react.useMemo)(function () {
    return _react["default"].Children.toArray(children).filter(function (e) {
      return /*#__PURE__*/_react["default"].isValidElement(e);
    });
  }, [children]);
};

var useStylesheet = function useStylesheet() {
  var _useTheme = (0, _providers.useTheme)(),
      borderPrimaryDark = _useTheme.borderPrimaryDark,
      surfaceLightest = _useTheme.surfaceLightest;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        border: "solid 1px ".concat(new _color["default"](borderPrimaryDark).alpha(0.5).toString()),
        paddingTop: "23px",
        paddingBottom: "23px",
        backgroundColor: surfaceLightest
      }
    });
  }, [borderPrimaryDark, surfaceLightest]);
};